import { render, staticRenderFns } from "./IndexOriginality.vue?vue&type=template&id=0db4f53a&scoped=true&"
import script from "./IndexOriginality.vue?vue&type=script&lang=js&"
export * from "./IndexOriginality.vue?vue&type=script&lang=js&"
import style0 from "./IndexOriginality.vue?vue&type=style&index=0&id=0db4f53a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4f53a",
  null
  
)

export default component.exports